import React, { PureComponent } from 'react';
import { login, loginAdfs, loginAzureAd } from '../../../api';
import { getWindowUrlParams } from '../../../../../utils/url';
import { actionTypeEnum, PROVIDER_ENUM } from '../../../consts';

const AuthenticationLoginController = (OriginalComponent) =>
	class extends PureComponent {
		state = {
			metadata: {},
			errors: null,
			urlParams: {},
			isLoginPending: false,
		};

		static getDerivedStateFromProps(nextProps) {
			if (nextProps.actionType === actionTypeEnum.LOGIN) {
				return {
					isLoginPending: true,
				};
			}

			return null;
		}

		async componentDidMount() {
			const { actionType, initialize, forgotPasswordEmail, fetchAuthData } = this.props;
			const { email, redirecturl, provider, errorcode, platformurl } = getWindowUrlParams({ toLowerCase: true });
			const correctedEmail = email || forgotPasswordEmail;

			if (correctedEmail) {
				initialize({
					email: correctedEmail,
				});
			}

			const newState = {
				urlParams: {
					email: correctedEmail,
					redirecturl,
				},
			};

			if (errorcode) {
				newState.errors = {
					_: {
						[errorcode]: {
							platformurl,
						},
					},
				};
			}

			await this.setState(newState);

			if (provider === PROVIDER_ENUM.AZURE_AD) {
				this.handleAzureAdLogin();
			}

			if (provider === PROVIDER_ENUM.ADFS) {
				this.handleADFSLogin();
			}

			if (actionTypeEnum.LOGIN_FORM_GET === actionType) {
				fetchAuthData();
			}

			if (actionTypeEnum.LOGIN === actionType) {
				login().then(this.handleLoginSuccess).catch(this.handleLoginError);
			}
		}

		handleFormSubmit = (values) => {
			this.setState({
				errors: null,
				isLoginPending: true,
			});

			login({
				...this.state.urlParams,
				...values,
			})
				.then(this.handleLoginSuccess)
				.catch(this.handleLoginError);
		};

		handleADFSLogin = () => {
			this.setState({
				isLoginPending: true,
			});

			loginAdfs(this.state.urlParams).then(this.handleLoginSuccess).catch(this.handleLoginError);
		};

		handleAzureAdLogin = () => {
			this.setState({
				isLoginPending: true,
			});

			loginAzureAd(this.state.urlParams).then(this.handleLoginSuccess).catch(this.handleLoginError);
		};

		handleLoginSuccess = ({ data }) => {
			if (data.action) {
				if (data.action === actionTypeEnum.MULTIPLE_ORGANIZATION_CONFLICT && data.metadata) {
					this.setState({
						metadata: data.metadata,
						isLoginPending: false,
					});
				}

				this.props.authenticationSetActionType(data.action);
			}
		};

		handleLoginError = (error) => {
			const { response } = error;

			if (response) {
				if (response.status === 302) return;

				if (response.status === 400 && response.data) {
					const errorData = response.data.errors;

					if (errorData && errorData._) {
						const { clearFields } = this.props;

						clearFields(false, true, 'password');
					}

					this.setState({
						errors: response.data.errors,
						isLoginPending: false,
					});
				} else {
					this.setState({
						isLoginPending: false,
					});
				}
			}
		};

		render() {
			return (
				<OriginalComponent
					{...this.state}
					{...this.props}
					handleFormSubmit={this.handleFormSubmit}
					handleADFSLogin={this.handleADFSLogin}
					handleAzureAdLogin={this.handleAzureAdLogin}
				/>
			);
		}
	};

export default AuthenticationLoginController;
